import { useWizardListener } from '@mwkt/react-magic-frame';

import { MagicFrameWizardEvent } from '../constants';

const useWizardSetSessionStorageListener = () => {
  useWizardListener({ event: MagicFrameWizardEvent.SetSessionStorage, callback: (data) => {
    Object.entries(data).forEach(([key, value]) => {
      sessionStorage.setItem(key, value as string);
    });
  } });
};

export default useWizardSetSessionStorageListener;
